function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Note");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Coach-Desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Coach-Dashboard",
  transform: "translate(-1003.000000, -530.000000)",
  fill: "#5C7CE2",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-17",
  transform: "translate(950.000000, 253.000000)"
}, React.createElement("path", {
  d: "M65.6250144,292.14286 C66.0686533,292.14286 66.4285868,291.782926 66.4285868,291.339287 L66.4285868,282.499991 L61.8750099,282.499991 C61.431371,282.499991 61.0714286,282.140058 61.0714286,281.696419 L61.0714286,277.142842 L54.375001,277.142842 C53.931362,277.142842 53.5714286,277.502775 53.5714286,277.946414 L53.5714286,291.339287 C53.5714286,291.782926 53.931362,292.14286 54.375001,292.14286 L65.6250144,292.14286 Z M66.0937649,281.428561 C66.01843,281.311374 65.9430951,281.210927 65.8593896,281.127222 L62.444207,277.712039 C62.3605015,277.628333 62.260055,277.552999 62.1428674,277.477664 L62.1428674,281.428561 L66.0937649,281.428561 Z M62.9464397,284.642851 L57.0535756,284.642851 C56.9029058,284.642851 56.7857181,284.525663 56.7857181,284.374993 L56.7857181,283.839278 C56.7857181,283.688609 56.9029058,283.571421 57.0535756,283.571421 L62.9464397,283.571421 C63.0971096,283.571421 63.2142972,283.688609 63.2142972,283.839278 L63.2142972,284.374993 C63.2142972,284.525663 63.0971096,284.642851 62.9464397,284.642851 Z M62.9464397,286.78571 L57.0535756,286.78571 C56.9029058,286.78571 56.7857181,286.668523 56.7857181,286.517853 L56.7857181,285.982138 C56.7857181,285.831468 56.9029058,285.714281 57.0535756,285.714281 L62.9464397,285.714281 C63.0971096,285.714281 63.2142972,285.831468 63.2142972,285.982138 L63.2142972,286.517853 C63.2142972,286.668523 63.0971096,286.78571 62.9464397,286.78571 Z M62.9464397,288.92857 L57.0535756,288.92857 C56.9029058,288.92857 56.7857181,288.811383 56.7857181,288.660713 L56.7857181,288.124998 C56.7857181,287.974328 56.9029058,287.85714 57.0535756,287.85714 L62.9464397,287.85714 C63.0971096,287.85714 63.2142972,287.974328 63.2142972,288.124998 L63.2142972,288.660713 C63.2142972,288.811383 63.0971096,288.92857 62.9464397,288.92857 Z",
  id: "Note"
}))));

var SvgIconNote = function SvgIconNote(props) {
  return React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-note.ddd71e63.svg";
export { SvgIconNote as ReactComponent };